<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-14 15:45:18
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-14 20:06:52
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\delDialog\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog title="提示" :visible.sync="visible" :before-close="beforeClose" width="400px">
		<p>
			<i class="el-icon-info yx-color-warning fz-16"></i>
			<span class="yx-color-pure-1 ml-6 font-h4-regular">是否确认删除？</span>
		</p>
		<p class="yx-color-text-p-4 font-h4-regular mt-8">删除后将不保留记录，是否确认删除？</p>
		<div slot="footer" class="footer-dialog">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="confirm">确 认</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { delBanner, delGatherPage, delIcons } from '@/api/selectionDecoration';
export default {
	props: {
		platformId: {
			type: [String, Number],
			default: 1,
		},
	},
	data() {
		return {
			visible: false,
			id: '',
			type: '1', //1banner配置2金刚位配置3橱窗配置4集合页配置
		};
	},
	methods: {
		show(id, type = '1') {
			this.type = type;
			this.id = id;
			this.visible = true;
		},
		async confirm() {
			const { id, type, platformId } = this;
			const api = {
				1: delBanner,
				2: delIcons,
				4: delGatherPage,
			};
			await api[type]({ id, platformId });
			this.$message.success('删除成功');
			this.$emit('refresh');
			this.beforeClose();
		},
		beforeClose() {
			this.visible = false;
		},
	},
};
</script>
<style lang="less" scoped></style>
